/**
 * PATH: packages/job-hub/src/jobs/qa/downloadBlobFile.ts
 * FILE_ID: JOBHUB-QA-BLOB-DOWNLOAD-001
 * PURPOSE: Hand a fetched blob to the browser as a named file download.
 * LANDMINE: the object URL must be revoked after the click or the blob is
 *   pinned in memory for the life of the tab. Every caller uses THIS, so the
 *   revoke cannot be forgotten in one copy and remembered in another.
 */
export function downloadBlobAsFile(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

/** Navigate to the Django download URL. The view 302s to S3; the browser
 *  follows without the JWT Authorization header axios would forward. */
export function openQaReportDownload(url: string): void {
  const link = document.createElement('a')
  link.href = url
  link.rel = 'noopener'
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

type SaveFilePicker = (options: {
  suggestedName?: string
  types?: Array<{ description?: string; accept: Record<string, string[]> }>
}) => Promise<FileSystemFileHandle>

export async function pickPdfSaveLocation(suggestedName: string): Promise<FileSystemFileHandle | null> {
  const pick = (window as Window & { showSaveFilePicker?: SaveFilePicker }).showSaveFilePicker
  if (typeof pick !== 'function') return null
  return pick({
    suggestedName,
    types: [{ description: 'PDF', accept: { 'application/pdf': ['.pdf'] } }],
  })
}

export async function writePdfToHandleOrDownload(
  blob: Blob,
  filename: string,
  handle: FileSystemFileHandle | null,
): Promise<void> {
  if (handle) {
    const writable = await handle.createWritable()
    await writable.write(blob)
    await writable.close()
    return
  }
  downloadBlobAsFile(blob, filename)
}
